import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { SentimentReportTypeEnum } from '../../../common/enum/sentiment/sentiment-report-type.enum';
import { ISentimentReportEnum } from '../../../common/enum/sentiment/sentiment-report.enum';
import { SelfSentimentReportEntity } from '../../../core/domain/entities/sentiment/self-sentiment-report.entity';
import { SentimentReportScore } from '../../../interface/dtos/sentiment/sentiment-report-score.dto';

export class ISelfSentimentReportPersistenceResponse {
  @IsNotEmpty()
  [ISentimentReportEnum.LocalDate]: string;
  @IsNotEmpty()
  [ISentimentReportEnum.ReportType]: string;
  @IsNotEmpty()
  [ISentimentReportEnum.Score]: string;
}

export class SelfSentimentReportMapper
  implements Mapper<SelfSentimentReportEntity, SentimentReportScore>
{
  toDomain(
    record: ISelfSentimentReportPersistenceResponse
  ): SelfSentimentReportEntity {
    return SelfSentimentReportMapper.toDomain(record);
  }
  static toDomain(
    record: ISelfSentimentReportPersistenceResponse
  ): SelfSentimentReportEntity {
    const entity = SelfSentimentReportEntity.create({
      localDate: new Date(record[ISentimentReportEnum.LocalDate]),
      reportType: record[
        ISentimentReportEnum.ReportType
      ] as SentimentReportTypeEnum,
      score: Number(record[ISentimentReportEnum.Score]),
    });
    return entity;
  }

  toResponse(entity: SelfSentimentReportEntity): SentimentReportScore {
    return SelfSentimentReportMapper.toResponse(entity);
  }

  static toResponse(entity: SelfSentimentReportEntity): SentimentReportScore {
    return {
      date: entity.localDate.toISOString(),
      score: String(entity.score),
      count: 1,
      percentageOfTotal: `${entity.percentageOfTotal}`,
      type: entity.reportType,
    };
  }
}
